import { TCreateOrUpdateRenewVisaUploadFileDocumentReqDto } from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-upload-file-document.dto";
import { TRenewVisaUploadFileForm } from "@/features/renew-visa/types/renewVisaUploadFileForm";

export const convertUploadApplicationFormDataToReqDto = (
  data: TRenewVisaUploadFileForm,
  filterConditionArrayKeys: (keyof TRenewVisaUploadFileForm)[],
  isDraft: boolean,
): TCreateOrUpdateRenewVisaUploadFileDocumentReqDto => {
  return {
    annualSalaryReportCopyFilePath:
      data && filterConditionArrayKeys.includes("annualSalaryReportCopyFilePath") ? data.annualSalaryReportCopyFilePath ?? null : null,
    applicantListFilePath: data && filterConditionArrayKeys.includes("applicantListFilePath") ? data.applicantListFilePath ?? null : null,
    applicantIndividualResidentTaxCertFilePath:
      data && filterConditionArrayKeys.includes("applicantIndividualResidentTaxCertFilePath")
        ? data.applicantIndividualResidentTaxCertFilePath ?? null
        : null,
    applicantIndividualResidentTaxCertInput: data.applicantIndividualResidentTaxCertInput,
    applicantResidentTaxPaymentCertFilePath:
      data && filterConditionArrayKeys.includes("applicantResidentTaxPaymentCertFilePath")
        ? data.applicantResidentTaxPaymentCertFilePath ?? null
        : null,
    applicantResidentTaxPaymentCertInput: data.applicantResidentTaxPaymentCertInput,
    applicantWithholdingSlipCopyFilePath:
      data && filterConditionArrayKeys.includes("applicantWithholdingSlipCopyFilePath") ? data.applicantWithholdingSlipCopyFilePath ?? null : null,
    applicantWithholdingSlipCopyInput: data.applicantWithholdingSlipCopyInput,
    careWorkplaceOverviewFilePath:
      data && filterConditionArrayKeys.includes("careWorkplaceOverviewFilePath") ? data.careWorkplaceOverviewFilePath ?? null : null,
    annualCalendarWithLanguageFilePath:
      data && filterConditionArrayKeys.includes("annualCalendarWithLanguageFilePath") ? data.annualCalendarWithLanguageFilePath ?? null : null,
    annualVariableWorkAgreementFilePath:
      data && filterConditionArrayKeys.includes("annualVariableWorkAgreementFilePath") ? data.annualVariableWorkAgreementFilePath ?? null : null,
    certifiedCompanyProofFilePath:
      data && filterConditionArrayKeys.includes("certifiedCompanyProofFilePath") ? data.certifiedCompanyProofFilePath ?? null : null,
    corporateResidentTaxPaymentCertFilePath:
      data && filterConditionArrayKeys.includes("corporateResidentTaxPaymentCertFilePath")
        ? data.corporateResidentTaxPaymentCertFilePath ?? null
        : null,
    corporateResidentTaxPaymentCertInput: data.corporateResidentTaxPaymentCertInput,
    specifiedSkillAutomobileMaintenanceCertFilePath:
      data && filterConditionArrayKeys.includes("specifiedSkillAutomobileMaintenanceCertFilePath")
        ? data.specifiedSkillAutomobileMaintenanceCertFilePath ?? null
        : null,
    specifiedSkillAutomobileMaintenanceIssuranceFilePath:
      data && filterConditionArrayKeys.includes("specifiedSkillAutomobileMaintenanceIssuranceFilePath")
        ? data.specifiedSkillAutomobileMaintenanceIssuranceFilePath ?? null
        : null,
    councilMembershipCertFilePath:
      data && filterConditionArrayKeys.includes("councilMembershipCertFilePath") ? data.councilMembershipCertFilePath ?? null : null,
    hotelBusinessLicenseFilePath:
      data && filterConditionArrayKeys.includes("hotelBusinessLicenseFilePath") ? data.hotelBusinessLicenseFilePath ?? null : null,
    hotelBusinessLicenseInput: data.hotelBusinessLicenseInput,
    documentOmissionPledgeFilePath:
      data && filterConditionArrayKeys.includes("documentOmissionPledgeFilePath") ? data.documentOmissionPledgeFilePath ?? null : null,
    employmentConditionsCopyFilePaths:
      data && filterConditionArrayKeys.includes("employmentConditionsCopyFilePaths")
        ? data.employmentConditionsCopyFilePaths && data.employmentConditionsCopyFilePaths.length > 0
          ? data.employmentConditionsCopyFilePaths
          : null
        : null,
    isExistEmploymentContractCopyFilePath: data.isExistEmploymentContractCopyFilePath || false,
    isExistWagePaymentFilePath: data.isExistWagePaymentFilePath || false,
    isExistEmploymentConditionsCopyFilePaths: data.isExistEmploymentConditionsCopyFilePaths || false,
    employmentContractCopyFilePath:
      data && filterConditionArrayKeys.includes("employmentContractCopyFilePath") ? data.employmentContractCopyFilePath ?? null : null,
    executiveResidentRecordCopyFilePath:
      data && filterConditionArrayKeys.includes("executiveResidentRecordCopyFilePath") ? data.executiveResidentRecordCopyFilePath ?? null : null,
    executiveResidentRecordCopyInput: data.executiveResidentRecordCopyInput,
    foreignWorkerCompensationStatementFilePaths:
      data && filterConditionArrayKeys.includes("foreignWorkerCompensationStatementFilePaths")
        ? data.foreignWorkerCompensationStatementFilePaths && data.foreignWorkerCompensationStatementFilePaths.length > 0
          ? data.foreignWorkerCompensationStatementFilePaths
          : null
        : null,
    foreignWorkerCompensationStatementInput: data.foreignWorkerCompensationStatementInput,
    healthInsuranceWelfarePensionCertFilePath:
      data && filterConditionArrayKeys.includes("healthInsuranceWelfarePensionCertFilePath")
        ? data.healthInsuranceWelfarePensionCertFilePath ?? null
        : null,
    healthInsuranceWelfarePensionCertInput: data.healthInsuranceWelfarePensionCertInput,
    immigrationElectronicSystemPledgeFilePath:
      data && filterConditionArrayKeys.includes("immigrationElectronicSystemPledgeFilePath")
        ? data.immigrationElectronicSystemPledgeFilePath ?? null
        : null,
    individualBusinessOwnerResidentCertFilePath:
      data && filterConditionArrayKeys.includes("individualBusinessOwnerResidentCertFilePath")
        ? data.individualBusinessOwnerResidentCertFilePath ?? null
        : null,
    individualBusinessOwnerResidentCertInput: data.individualBusinessOwnerResidentCertInput,
    specifiedSkillForeignWorkerPledgeFilePath:
      data && filterConditionArrayKeys.includes("specifiedSkillForeignWorkerPledgeFilePath")
        ? data.specifiedSkillForeignWorkerPledgeFilePath ?? null
        : null,
    specifiedSkillForeignWorkerPledgeInput: data.specifiedSkillForeignWorkerPledgeInput,
    constructionSpecifiedSkillAcceptancePlanCertFilePath:
      data && filterConditionArrayKeys.includes("constructionSpecifiedSkillAcceptancePlanCertFilePath")
        ? data.constructionSpecifiedSkillAcceptancePlanCertFilePath ?? null
        : null,
    constructionSpecifiedSkillAcceptancePlanCertInput: data.constructionSpecifiedSkillAcceptancePlanCertInput,
    individualBusinessOwnerTaxOfficePaymentCertNo3FilePath:
      data && filterConditionArrayKeys.includes("individualBusinessOwnerTaxOfficePaymentCertNo3FilePath")
        ? data.individualBusinessOwnerTaxOfficePaymentCertNo3FilePath ?? null
        : null,
    individualBusinessOwnerTaxOfficePaymentCertNo3Input: data.individualBusinessOwnerTaxOfficePaymentCertNo3Input,
    individualHealthInsurancePaymentCertFilePath:
      data && filterConditionArrayKeys.includes("individualHealthInsurancePaymentCertFilePath")
        ? data.individualHealthInsurancePaymentCertFilePath ?? null
        : null,
    individualHealthInsurancePaymentCertInput: data.individualHealthInsurancePaymentCertInput,
    individualPensionReceiptCopyFilePath:
      data && filterConditionArrayKeys.includes("individualPensionReceiptCopyFilePath") ? data.individualPensionReceiptCopyFilePath ?? null : null,
    individualPensionReceiptCopyInput: data.individualPensionReceiptCopyInput,
    individualResidentTaxCertFilePath:
      data && filterConditionArrayKeys.includes("individualResidentTaxCertFilePath") ? data.individualResidentTaxCertFilePath ?? null : null,
    individualResidentTaxCertInput: data.individualResidentTaxCertInput,
    innovationCompanyProofFilePath:
      data && filterConditionArrayKeys.includes("innovationCompanyProofFilePath") ? data.innovationCompanyProofFilePath ?? null : null,
    laborInsuranceDelegationFilePath:
      data && filterConditionArrayKeys.includes("laborInsuranceDelegationFilePath") ? data.laborInsuranceDelegationFilePath ?? null : null,
    laborInsuranceDelegationInput: data.laborInsuranceDelegationInput,
    laborInsuranceNoDelegationFilePath:
      data && filterConditionArrayKeys.includes("laborInsuranceNoDelegationFilePath") ? data.laborInsuranceNoDelegationFilePath ?? null : null,
    laborInsuranceNoDelegationInput: data.laborInsuranceNoDelegationInput,
    nonHealthInsuranceWelfarePensionCertFilePath:
      data && filterConditionArrayKeys.includes("nonHealthInsuranceWelfarePensionCertFilePath")
        ? data.nonHealthInsuranceWelfarePensionCertFilePath ?? null
        : null,
    nonHealthInsuranceWelfarePensionCertInput: data.nonHealthInsuranceWelfarePensionCertInput,
    quarterlyReportCopyFilePath:
      data && filterConditionArrayKeys.includes("quarterlyReportCopyFilePath") ? data.quarterlyReportCopyFilePath ?? null : null,
    registrationCertFilePath: data && filterConditionArrayKeys.includes("registrationCertFilePath") ? data.registrationCertFilePath ?? null : null,
    registrationCertInput: data.registrationCertInput,
    socialInsurancePaymentStatusCertFilePath:
      data && filterConditionArrayKeys.includes("socialInsurancePaymentStatusCertFilePath")
        ? data.socialInsurancePaymentStatusCertFilePath ?? null
        : null,
    socialInsurancePaymentStatusCertInput: data.socialInsurancePaymentStatusCertInput,
    specificSkillsInstitutionOfficerAffidavitFilePath:
      data && filterConditionArrayKeys.includes("specificSkillsInstitutionOfficerAffidavitFilePath")
        ? data.specificSkillsInstitutionOfficerAffidavitFilePath ?? null
        : null,
    specificSkillsInstitutionOfficerAffidavitInput: data.specificSkillsInstitutionOfficerAffidavitInput,
    specificSkillsInstitutionOverviewDocumentFilePath:
      data && filterConditionArrayKeys.includes("specificSkillsInstitutionOverviewDocumentFilePath")
        ? data.specificSkillsInstitutionOverviewDocumentFilePath ?? null
        : null,
    specificSkillsInstitutionOverviewDocumentInput: data.specificSkillsInstitutionOverviewDocumentInput,
    taxOfficePaymentCertNo3FilePath:
      data && filterConditionArrayKeys.includes("taxOfficePaymentCertNo3FilePath") ? data.taxOfficePaymentCertNo3FilePath ?? null : null,
    taxOfficePaymentCertNo3Input: data.taxOfficePaymentCertNo3Input,
    wagePaymentFilePath: data && filterConditionArrayKeys.includes("wagePaymentFilePath") ? data.wagePaymentFilePath ?? null : null,
    applicantHealthInsuranceCardCopyFilePath:
      data && filterConditionArrayKeys.includes("applicantHealthInsuranceCardCopyFilePath")
        ? data.applicantHealthInsuranceCardCopyFilePath ?? null
        : null,
    applicantHealthInsuranceCardCopyInput: data.applicantHealthInsuranceCardCopyInput,
    applicantHealthInsuranceRecordInquiryResponseFilePath:
      data && filterConditionArrayKeys.includes("applicantHealthInsuranceRecordInquiryResponseFilePath")
        ? data.applicantHealthInsuranceRecordInquiryResponseFilePath ?? null
        : null,
    applicantHealthInsuranceRecordInquiryResponseInput: data.applicantHealthInsuranceRecordInquiryResponseInput,
    applicantHealthInsurancePaymentCertFilePath:
      data && filterConditionArrayKeys.includes("applicantHealthInsurancePaymentCertFilePath")
        ? data.applicantHealthInsurancePaymentCertFilePath ?? null
        : null,
    applicantHealthInsurancePaymentCertInput: data.applicantHealthInsurancePaymentCertInput,
    applicantPensionReceiptCopy1FilePath:
      data && filterConditionArrayKeys.includes("applicantPensionReceiptCopy1FilePath") ? data.applicantPensionReceiptCopy1FilePath ?? null : null,
    applicantPensionReceiptCopy1Input: data.applicantPensionReceiptCopy1Input,
    applicantPensionRecordInquiry2FilePath:
      data && filterConditionArrayKeys.includes("applicantPensionRecordInquiry2FilePath")
        ? data.applicantPensionRecordInquiry2FilePath ?? null
        : null,
    applicantPensionRecordInquiry2Input: data.applicantPensionRecordInquiry2Input,
    buildingEnvHealthMgmtRegistrationCertFilePath:
      data && filterConditionArrayKeys.includes("buildingEnvHealthMgmtRegistrationCertFilePath")
        ? data.buildingEnvHealthMgmtRegistrationCertFilePath ?? null
        : null,
    buildingEnvHealthMgmtRegistrationCertInput: data.buildingEnvHealthMgmtRegistrationCertInput,
    registeredCorporateStructureListPrintedFilePath:
      data && filterConditionArrayKeys.includes("registeredCorporateStructureListPrintedFilePath")
        ? data.registeredCorporateStructureListPrintedFilePath ?? null
        : null,
    fishingBoatRegistrationCertCopyFilePath:
      data && filterConditionArrayKeys.includes("fishingBoatRegistrationCertCopyFilePath")
        ? data.fishingBoatRegistrationCertCopyFilePath ?? null
        : null,
    fishingBoatRegistrationCertCopyInput: data.fishingBoatRegistrationCertCopyInput,
    fishingBoatRegistryCopyFilePath:
      data && filterConditionArrayKeys.includes("fishingBoatRegistryCopyFilePath") ? data.fishingBoatRegistryCopyFilePath ?? null : null,
    fishingBoatRegistryCopyInput: data.fishingBoatRegistryCopyInput,
    fishingCooperativeMembershipDocumentFilePath:
      data && filterConditionArrayKeys.includes("fishingCooperativeMembershipDocumentFilePath")
        ? data.fishingCooperativeMembershipDocumentFilePath ?? null
        : null,
    fishingCooperativeMembershipDocumentInput: data.fishingCooperativeMembershipDocumentInput,
    fishingCooperativeRightsDocumentFilePath:
      data && filterConditionArrayKeys.includes("fishingCooperativeRightsDocumentFilePath")
        ? data.fishingCooperativeRightsDocumentFilePath ?? null
        : null,
    fishingCooperativeRightsDocumentInput: data.fishingCooperativeRightsDocumentInput,
    fishingLicenseCopy1FilePath:
      data && filterConditionArrayKeys.includes("fishingLicenseCopy1FilePath") ? data.fishingLicenseCopy1FilePath ?? null : null,
    fishingLicenseCopy1Input: data.fishingLicenseCopy1Input,
    fishingLicenseCopy2FilePath:
      data && filterConditionArrayKeys.includes("fishingLicenseCopy2FilePath") ? data.fishingLicenseCopy2FilePath ?? null : null,
    fishingLicenseCopy2Input: data.fishingLicenseCopy2Input,
    fishingLicenseCopy3FilePath:
      data && filterConditionArrayKeys.includes("fishingLicenseCopy3FilePath") ? data.fishingLicenseCopy3FilePath ?? null : null,
    fishingLicenseCopy3Input: data.fishingLicenseCopy3Input,
    previousApplicationDocumentsFilePath:
      data && filterConditionArrayKeys.includes("previousApplicationDocumentsFilePath") ? data.previousApplicationDocumentsFilePath ?? null : null,
    publicDutyPledgeFilePath: data && filterConditionArrayKeys.includes("publicDutyPledgeFilePath") ? data.publicDutyPledgeFilePath ?? null : null,
    publicDutyComplianceFilePath:
      data && filterConditionArrayKeys.includes("publicDutyComplianceFilePath") ? data.publicDutyComplianceFilePath ?? null : null,
    shipbuildingIndustryConfirmationFilePath:
      data && filterConditionArrayKeys.includes("shipbuildingIndustryConfirmationFilePath")
        ? data.shipbuildingIndustryConfirmationFilePath ?? null
        : null,
    shipbuildingIndustryConfirmationInput: data.shipbuildingIndustryConfirmationInput,
    ryokanBusinessLicenseFilePath:
      data && filterConditionArrayKeys.includes("ryokanBusinessLicenseFilePath") ? data.ryokanBusinessLicenseFilePath ?? null : null,
    ryokanBusinessLicenseInput: data.ryokanBusinessLicenseInput,
    adultEntertainmentBusinessLicenseFilePath:
      data && filterConditionArrayKeys.includes("adultEntertainmentBusinessLicenseFilePath")
        ? data.adultEntertainmentBusinessLicenseFilePath ?? null
        : null,
    adultEntertainmentBusinessLicenseInput: data.adultEntertainmentBusinessLicenseInput,
    businessLicenseOrNotificationFormFilePath:
      data && filterConditionArrayKeys.includes("businessLicenseOrNotificationFormFilePath")
        ? data.businessLicenseOrNotificationFormFilePath ?? null
        : null,
    businessLicenseOrNotificationFormInput: data.businessLicenseOrNotificationFormInput,
    specificSkillOrganizationOverviewFilePath:
      data && filterConditionArrayKeys.includes("specificSkillOrganizationOverviewFilePath")
        ? data.specificSkillOrganizationOverviewFilePath ?? null
        : null,
    specificSkillOrganizationOverviewInput: data.specificSkillOrganizationOverviewInput,
    residenceApplicationsForEmployeeTable1FilePath:
      data && data.residenceApplicationsForEmployeeTable1FilePath ? data.residenceApplicationsForEmployeeTable1FilePath : null,
    residenceApplicationsForEmployeeTable2And1FilePath:
      data && data.residenceApplicationsForEmployeeTable2And1FilePath ? data.residenceApplicationsForEmployeeTable2And1FilePath : null,
    residenceApplicationsForEmployeeTable2And2FilePath:
      data && data.residenceApplicationsForEmployeeTable2And2FilePath ? data.residenceApplicationsForEmployeeTable2And2FilePath : null,
    residenceApplicationsForEmployeeTable2And3FilePath:
      data && data.residenceApplicationsForEmployeeTable2And3FilePath ? data.residenceApplicationsForEmployeeTable2And3FilePath : null,
    residenceApplicationsForEmployeeTable3And1FilePath:
      data && data.residenceApplicationsForEmployeeTable3And1FilePath ? data.residenceApplicationsForEmployeeTable3And1FilePath : null,
    residenceApplicationsForEmployeeTable3And2FilePath:
      data && data.residenceApplicationsForEmployeeTable3And2FilePath ? data.residenceApplicationsForEmployeeTable3And2FilePath : null,
    residenceApplicationsForEmployeeTable3And3FilePath:
      data && data.residenceApplicationsForEmployeeTable3And3FilePath ? data.residenceApplicationsForEmployeeTable3And3FilePath : null,
    isDraft,
  };
};
